import styled from "@emotion/styled";
import {DefaultColors} from "@cirrus/legacy/app-components/app/styles/colors/colors-default";

export const SearchContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 20px;
`

export const WrapSearch = styled.div`
  display: inline-block;

  .icon {
    padding: 0 5px;
    margin-left: 1px;
    border-radius: 4px;
    width: 22px;
    text-align: center;

    &:hover {
      background-color: ${DefaultColors.gray_800};
      cursor: pointer;
    }
  }
`

/* Match counter ("3 / 59") between the search input and the prev/next arrows.
 * Sized/offset to sit on the same visual line as the input (the input itself
 * is 11px with top: -6px). */
export const MatchesCountSpan = styled.span`
  display: inline-block;
  position: relative;
  top: -3px;
  color: ${DefaultColors.white};
  font-size: 11px;
  line-height: 25px;
  white-space: nowrap;
  padding-right: 6px;
`
